export var expansion = function expansion() {
  var degree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 180;
  return function (_ref) {
    var expanded = _ref.expanded;

    if (expanded) {
      return "transform: rotate(".concat(degree, "deg);");
    }

    return '';
  };
};